import { f as $, s as N, i as B, T as q, p as G } from "./tss-DN0acMKN.mjs";
import { i as _, a as J, s as Q } from "./generateUtilityClass-DMFG5-Cu.mjs";
import * as D from "react";
import { j as U } from "./jsx-runtime-3tyXYecC.mjs";
function W(e) {
  const {
    variants: o,
    ...t
  } = e, r = {
    variants: o,
    style: _(t),
    isProcessed: !0
  };
  return r.style === t || o && o.forEach((n) => {
    typeof n.style != "function" && (n.style = _(n.style));
  }), r;
}
const X = $();
function b(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function Y(e) {
  return e ? (o, t) => t[e] : null;
}
function Z(e, o, t) {
  e.theme = ne(e.theme) ? t : e.theme[o] || e.theme;
}
function O(e, o) {
  const t = typeof o == "function" ? o(e) : o;
  if (Array.isArray(t))
    return t.flatMap((r) => O(e, r));
  if (Array.isArray(t == null ? void 0 : t.variants)) {
    let r;
    if (t.isProcessed)
      r = t.style;
    else {
      const {
        variants: n,
        ...a
      } = t;
      r = a;
    }
    return V(e, t.variants, [r]);
  }
  return t != null && t.isProcessed ? t.style : t;
}
function V(e, o, t = []) {
  var n;
  let r;
  e: for (let a = 0; a < o.length; a += 1) {
    const s = o[a];
    if (typeof s.props == "function") {
      if (r ?? (r = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !s.props(r))
        continue;
    } else
      for (const i in s.props)
        if (e[i] !== s.props[i] && ((n = e.ownerState) == null ? void 0 : n[i]) !== s.props[i])
          continue e;
    typeof s.style == "function" ? (r ?? (r = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), t.push(s.style(r))) : t.push(s.style);
  }
  return t;
}
function ee(e = {}) {
  const {
    themeId: o,
    defaultTheme: t = X,
    rootShouldForwardProp: r = b,
    slotShouldForwardProp: n = b
  } = e;
  function a(i) {
    Z(i, o, t);
  }
  return (i, f = {}) => {
    J(i, (u) => u.filter((c) => c !== N));
    const {
      name: m,
      slot: h,
      skipVariantsResolver: R,
      skipSx: H,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: C = Y(re(h)),
      ...I
    } = f, L = R !== void 0 ? R : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      h && h !== "Root" && h !== "root" || !1
    ), z = H || !1;
    let v = b;
    h === "Root" || h === "root" ? v = r : h ? v = n : oe(i) && (v = void 0);
    const T = Q(i, {
      shouldForwardProp: v,
      label: te(),
      ...I
    }), K = (u) => {
      if (typeof u == "function" && u.__emotion_real !== u)
        return function(S) {
          return O(S, u);
        };
      if (B(u)) {
        const c = W(u);
        return c.variants ? function(p) {
          return O(p, c);
        } : c.style;
      }
      return u;
    }, F = (...u) => {
      const c = [], S = u.map(K), p = [];
      if (c.push(a), m && C && p.push(function(d) {
        var P, j;
        const l = (j = (P = d.theme.components) == null ? void 0 : P[m]) == null ? void 0 : j.styleOverrides;
        if (!l)
          return null;
        const w = {};
        for (const k in l)
          w[k] = O(d, l[k]);
        return C(d, w);
      }), m && !L && p.push(function(d) {
        var w, P;
        const y = d.theme, l = (P = (w = y == null ? void 0 : y.components) == null ? void 0 : w[m]) == null ? void 0 : P.variants;
        return l ? V(d, l) : null;
      }), z || p.push(N), Array.isArray(S[0])) {
        const x = S.shift(), d = new Array(c.length).fill(""), y = new Array(p.length).fill("");
        let l;
        l = [...d, ...x, ...y], l.raw = [...d, ...x.raw, ...y], c.unshift(l);
      }
      const M = [...c, ...S, ...p], g = T(...M);
      return i.muiName && (g.muiName = i.muiName), g;
    };
    return T.withConfig && (F.withConfig = T.withConfig), F;
  };
}
function te(e, o) {
  return void 0;
}
function ne(e) {
  for (const o in e)
    return !1;
  return !0;
}
function oe(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function re(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
function A(e, o) {
  const t = {
    ...o
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const n = r;
      if (n === "components" || n === "slots")
        t[n] = {
          ...e[n],
          ...t[n]
        };
      else if (n === "componentsProps" || n === "slotProps") {
        const a = e[n], s = o[n];
        if (!s)
          t[n] = a || {};
        else if (!a)
          t[n] = s;
        else {
          t[n] = {
            ...s
          };
          for (const i in a)
            if (Object.prototype.hasOwnProperty.call(a, i)) {
              const f = i;
              t[n][f] = A(a[f], s[f]);
            }
        }
      } else t[n] === void 0 && (t[n] = e[n]);
    }
  return t;
}
function me(e, o, t = void 0) {
  const r = {};
  for (const n in e) {
    const a = e[n];
    let s = "", i = !0;
    for (let f = 0; f < a.length; f += 1) {
      const m = a[f];
      m && (s += (i === !0 ? "" : " ") + o(m), i = !1, t && t[m] && (s += " " + t[m]));
    }
    r[n] = s;
  }
  return r;
}
const E = /* @__PURE__ */ D.createContext(void 0);
function de({
  value: e,
  children: o
}) {
  return /* @__PURE__ */ U.jsx(E.Provider, {
    value: e,
    children: o
  });
}
function se(e) {
  const {
    theme: o,
    name: t,
    props: r
  } = e;
  if (!o || !o.components || !o.components[t])
    return r;
  const n = o.components[t];
  return n.defaultProps ? A(n.defaultProps, r) : !n.styleOverrides && !n.variants ? A(n, r) : r;
}
function ie({
  props: e,
  name: o
}) {
  const t = D.useContext(E);
  return se({
    props: e,
    name: o,
    theme: {
      components: t
    }
  });
}
function ae(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const ue = (e) => ae(e) && e !== "classes", he = ee({
  themeId: q,
  defaultTheme: G,
  rootShouldForwardProp: ue
});
function pe(e) {
  return ie(e);
}
export {
  de as D,
  ee as a,
  ue as b,
  me as c,
  ae as d,
  W as p,
  A as r,
  he as s,
  pe as u
};
//# sourceMappingURL=DefaultPropsProvider-CFfEbxdP.mjs.map
